import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "./animations";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import {
  getPlayerStats,
  getTeamStats,
  getTeamStatsSeason,
} from "../../../../shared/utils/opta/statsHandler";
import countries from "../../../../../language/de/countries.json";
import { useTranslation } from "react-i18next";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";
import Image from "../../../../shared/components/Image";
import {
  getDynamicLogoPath,
  toIsoDateString,
} from "../../../../shared/utils/functions";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/MatchScoreWidgetForBild";
import BildTeamLogo from "../../../../shared/components/Image/BildTeamLogo";

require("./style/style.scss");
require("./style/animation.scss");

const translations = {
  Group: "Gruppe",
};

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const { t } = useTranslation();

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const { options, fields, dynamic } = templateData;
  const matchInfo = _.get(dynamic, "matchInfo");
  const homeTeam = matchInfo?.home;
  const awayTeam = matchInfo?.away;

  const homeTeamSeason = _.get(dynamic, "homeTeamSeason");
  const awayTeamSeason = _.get(dynamic, "awayTeamSeason");
  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock class={`${isTimeline ? "" : "template-bild"}`}>
        {
          !isTimeline && <div className="main-header-content">
            <div className="main-header">
              {t("Team Compare Headline", { keyPrefix: "templates" })}
            </div>
            <MatchScoreWidget
              homeTeam={homeTeam}
              awayTeam={awayTeam}
              matchInfo={matchInfo}
            />
          </div>
        }
        <div className={"wc-content wc-content-v2"}>
          <ProgressBar height={"8px"} />
          <div className="main-content-side">
            <div className={"left-block-side"}>
              <div className={"team-logo-container home"}>
                <BildTeamLogo className="team-logo" id={homeTeam?.id}  />
                <div className={"team-name home"}>
                  {t(homeTeam?.microname, { ns: "countries" })}
                </div>
              </div>
              <div className="left-block-shadow"></div>
            </div>
            <div className={"center-block-side"}>
              <div className="center-row item-player">
                {/* "Games Played" */}
                <div className="item-row-left">
                  {homeTeamSeason?.goals}
                </div>
                <div className="item-row-center">
                  {t("Goals", { keyPrefix: "templates" })}
                </div>
                <div className="item-row-right">
                  {awayTeamSeason?.goals}
                </div>
              </div>

              <div className="center-row item-goal">
                <div className="item-row-left">
                  {homeTeamSeason?.shots}
                </div>
                <div className="item-row-center">
                  {t("Shots on goal", { keyPrefix: "templates" })}
                </div>
                <div className="item-row-right">
                  {awayTeamSeason?.shots}
                </div>
              </div>

              <div className="center-row item-shots">
                <div className="item-row-left">
                  {homeTeamSeason?.shotsOnGoal}
                </div>
                <div className="item-row-center">
                  {t("ontargetScoringAtt", { keyPrefix: "stats" })}
                </div>
                <div className="item-row-right">
                  {awayTeamSeason?.shotsOnGoal}
                </div>
              </div>

              <div className="center-row item-assist">
                <div className="item-row-left">
                  {parseFloat(homeTeamSeason?.duelsWonPercentage).toFixed(2)}
                </div>
                <div className="item-row-center">
                  {t("duelWon", { keyPrefix: "stats" })}
                </div>
                <div className="item-row-right">
                  {parseFloat(awayTeamSeason?.duelsWonPercentage).toFixed(2)}
                </div>
              </div>
            </div>

            <div className={"right-block-side"}>
              <div className={"team-logo-container away"}>
                <BildTeamLogo className="team-logo" id={awayTeam?.id}  />
                <div className={"team-name home"}>
                  {t(awayTeam?.microname, { ns: "countries" })}
                </div>
              </div>
              <div className="right-block-shadow"></div>
            </div>
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `background_1920`);
};

export default Index;
